import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Quote, Clock } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import "@/components/HomeOpinion.css";

function readingTime(html) {
  const text = (html || "").replace(/<[^>]+>/g, "").trim();
  const words = text.split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}

export default function OpinionPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/opinion/public", { params: { limit: 50 } })
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, []);

  return (
    <>
      <Header />
      <main className="max-w-[1280px] mx-auto px-4 md:px-8 py-10" data-testid="opinion-page">
        <header className="flex items-center gap-3 border-b pb-6 mb-10" style={{ borderColor: "var(--border)" }}>
          <Quote size={36} className="opinion-quote-icon" />
          <div>
            <p className="overline" style={{ color: "#ec4899" }}>POPU.NEWS</p>
            <h1 className="font-headline uppercase text-4xl md:text-6xl">Opinión</h1>
            <p className="mt-2 text-sm" style={{ color: "var(--text-muted)" }}>Las voces que marcan la conversación</p>
          </div>
        </header>

        {data?.items && data.items.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {data.items.map((art) => (
              <Link
                to={`/opinion/${art.slug}`}
                key={art.id}
                className="group block bg-[var(--surface)] border rounded-xl overflow-hidden transition hover:-translate-y-1 hover:shadow-xl"
                style={{ borderColor: "var(--border)" }}
                data-testid={`opinion-page-item-${art.slug}`}
              >
                {art.image && (
                  <div className="aspect-[16/9] overflow-hidden bg-gray-100">
                    <img src={art.image} alt={art.title} className="w-full h-full object-cover transition group-hover:scale-105" loading="lazy" />
                  </div>
                )}
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    {art.author?.photo_url && (
                      <img
                        src={art.author.photo_url}
                        alt={art.author.name}
                        className="w-10 h-10 rounded-full object-cover"
                        style={{ border: "2px solid #ec4899", boxShadow: "0 0 0 3px rgba(236,72,153,0.12)" }}
                      />
                    )}
                    <div>
                      <p className="text-sm font-bold">{art.author?.name}</p>
                      {art.author?.role && <p className="text-xs" style={{ color: "#ec4899" }}>{art.author.role}</p>}
                    </div>
                    <span className="ml-auto text-xs font-bold flex items-center gap-1" style={{ color: "var(--text-muted)" }}>
                      <Clock size={11} /> {readingTime(art.body)} min
                    </span>
                  </div>
                  <h2 className="font-headline uppercase text-xl leading-tight mb-2 group-hover:text-[#ec4899] transition">
                    {art.title}
                  </h2>
                  {art.lead && <p className="text-sm" style={{ color: "var(--text-muted)" }}>{art.lead}</p>}
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <p className="text-center py-20" style={{ color: "var(--text-muted)" }}>
            Aún no hay columnas de opinión publicadas.
          </p>
        )}
      </main>
      <Footer />
    </>
  );
}
